import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Home, Bug, Wrench, Coffee, Terminal } from 'lucide-react';

const NotFound = () => {
  const [isGlitching, setIsGlitching] = useState(false);
  const [currentTip, setCurrentTip] = useState(0);

  const funnyTips = [
    { icon: <Bug className="w-6 h-6" />, text: "Have you tried turning it off and on again?" },
    { icon: <Wrench className="w-6 h-6" />, text: "Maybe the page is just taking a coffee break" },
    { icon: <Coffee className="w-6 h-6" />, text: "404: Coffee not found. Developer needs refill" },
    { icon: <Terminal className="w-6 h-6" />, text: "sudo find -name 'missing-page.html'" }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTip((prev) => (prev + 1) % funnyTips.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const triggerGlitch = () => {
    setIsGlitching(true);
    setTimeout(() => setIsGlitching(false), 1000);
  };

  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%239C92AC' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }} />
      </div>
      
      <div className="container mx-auto px-6 py-24 text-center relative">
        <div className="max-w-2xl mx-auto">
          {/* Matrix-style binary rain in the background */}
          <div className="absolute inset-0 overflow-hidden opacity-20 pointer-events-none">
            {Array.from({ length: 10 }).map((_, i) => (
              <div
                key={i}
                className="absolute text-yellow-400 text-xs animate-fall"
                style={{
                  left: `${i * 10}%`,
                  animationDelay: `${i * 0.3}s`,
                  animationDuration: '3s'
                }}
              >
                {Array.from({ length: 20 }).map((_, j) => (
                  <div key={j}>{Math.random() > 0.5 ? '1' : '0'}</div>
                ))}
              </div>
            ))}
          </div>

          {/* Main content */}
          <div className={`relative ${isGlitching ? 'animate-glitch' : ''}`}>
            <div 
              className="text-[150px] font-bold text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-500 leading-none mb-8 cursor-pointer select-none"
              onClick={triggerGlitch}
            >
              404
            </div>
            <h2 className="text-3xl font-semibold text-white mb-6">
              Oops! Page Not Found
            </h2>
            <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 mb-8">
              <div className="h-20 flex items-center justify-center">
                <div className="flex items-center text-gray-300 space-x-3 transition-all duration-500">
                  {funnyTips[currentTip].icon}
                  <p>{funnyTips[currentTip].text}</p>
                </div>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to="/"
                className="px-6 py-3 bg-yellow-400 text-slate-900 rounded-lg font-semibold hover:bg-yellow-300 transition-all group flex items-center"
              >
                <Home className="w-5 h-5 mr-2" />
                Return Home
              </Link>
              <a
                href="mailto:support@stingerbuilds.com"
                className="px-6 py-3 border border-yellow-400/20 text-yellow-400 rounded-lg font-semibold hover:bg-yellow-400/10 transition-all"
              >
                Report Issue
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;